import React from 'react';
import { Head3 } from '../head3/Head3';

export const Main3 = () => {
	return (
		<>
			<Head3 />
		</>
	);
};
